import InsectDetectionsEditor from './InsectDetectionsEditor';

export default InsectDetectionsEditor;
